import { Fingerprint, ScrollText, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { Footer } from "@/components/Footer";
import { unlockAudio } from "@/lib/sound";

export default function Landing() {
  const handleLogin = () => {
    unlockAudio();
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen paper-texture" data-testid="landing-page">
      <header className="max-w-6xl mx-auto px-6 py-6 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Fingerprint className="text-[#1B4D3E]" size={26} strokeWidth={1.6} />
          <span className="font-serif-dl text-2xl font-semibold tracking-tight">Dap Ledger</span>
        </div>
        <button
          data-testid="header-login-btn"
          onClick={handleLogin}
          className="font-serif-dl tracking-wide text-[#1B4D3E] hover:text-[#143A2F] transition-colors"
        >
          Enter the Ledger
        </button>
      </header>

      <main className="max-w-6xl mx-auto px-6">
        <section className="grid lg:grid-cols-2 gap-16 items-center pt-10 lg:pt-20">
          <div className="animate-fade-up">
            <p className="overline text-[#E07A5F] mb-6">A community honor system</p>
            <h1 className="font-serif-dl text-5xl lg:text-7xl leading-[0.95] tracking-tight text-[#1A1A1A]">
              Give your word.
              <br />
              Seal it with a dap.
            </h1>
            <p className="mt-8 text-lg text-[#5C5A54] leading-relaxed max-w-md">
              Dap Ledger digitizes the handshake. Two people agree, both seal it
              with their own biometric, and it's written into a tamper-evident
              chain. Your standing is private by default — yours to share, honor,
              never a public credit score.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <button
                data-testid="hero-login-btn"
                onClick={handleLogin}
                className="bg-[#1B4D3E] text-white rounded-md px-8 py-4 font-serif-dl text-lg tracking-wide hover:bg-[#143A2F] transition-colors"
              >
                Continue with Google
              </button>
            </div>
            <p className="mt-4 text-sm text-[#8A877F]" data-testid="login-disclaimer">
              By continuing, you agree to our{" "}
              <Link
                to="/terms"
                data-testid="login-terms-link"
                className="text-[#1B4D3E] underline underline-offset-2 hover:text-[#143A2F] transition-colors"
              >
                Terms of Service
              </Link>
              .
            </p>

            <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg">
              {[
                { icon: Users, label: "Two-party pact" },
                { icon: Fingerprint, label: "Dual biometric seal" },
                { icon: ScrollText, label: "Tamper-evident chain" },
              ].map((f, i) => (
                <div key={f.label} className="text-center">
                  <f.icon className="mx-auto text-[#1B4D3E]" size={24} strokeWidth={1.4} />
                  <p className="mt-2 text-xs text-[#5C5A54] font-medium">{f.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="relative animate-fade-up" style={{ animationDelay: "0.15s" }}>
            <div className="rounded-2xl overflow-hidden border border-[#DEDBD3] shadow-sm">
              <img
                src="https://images.unsplash.com/photo-1594684197925-50758abcde61?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
                alt="Two hands meeting in trust"
                className="w-full h-[460px] object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white border border-[#DEDBD3] rounded-xl px-6 py-4 shadow-sm">
              <p className="overline text-[#5C5A54]">Honor, not credit</p>
              <p className="font-serif-dl text-2xl text-[#1B4D3E]">Kept between us.</p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
